/*                                    */
/*                                                       */
import { DEV } from 'esm-env';
import { FILENAME } from '../../constants.js';
import { is_firefox } from './dom/operations.js';
import { BOUNDARY_EFFECT, EFFECT_RAN } from './constants.js';
import { define_property, get_descriptor } from '../shared/utils.js';
import { active_effect } from './runtime.js';

/**
 *
 */
export function handle_error(error) {
	var effect = /*                 */ (active_effect);

	if (DEV && error instanceof Error) {
		adjust_error(error, effect);
	}

	if ((effect.f & EFFECT_RAN) === 0) {
		/*                                                           */
		/*                                                    */
		if ((effect.f & BOUNDARY_EFFECT) === 0) {
			throw error;
		}

		/*               */
		effect.fn(error);
	} else {
		/*                                               */
		invoke_error_boundary(error, effect);
	}
}

/**
 *
 *
 */
export function invoke_error_boundary(error, effect) {
	while (effect !== null) {
		if ((effect.f & BOUNDARY_EFFECT) !== 0) {
			try {
				/*                   */ (effect.b).error(error);
				return;
			} catch {}
		}

		effect = effect.parent;
	}

	throw error;
}

/*                         */
const adjusted_errors = new WeakSet();

/**
 *
 *
 *
 */
function adjust_error(error, effect) {
	if (adjusted_errors.has(error)) return;
	adjusted_errors.add(error);

	const message_descriptor = get_descriptor(error, 'message');

	/*                                                                              */
	/*                                                               */
	if (message_descriptor && !message_descriptor.configurable) return;

	var indent = is_firefox ? '  ' : '\t';
	var component_stack = `\n${indent}in ${effect.fn?.name || '<unknown>'}`;
	var context = effect.ctx;

	while (context !== null) {
		component_stack += `\n${indent}in ${context.function?.[FILENAME].split('/').pop()}`;
		context = context.p;
	}

	define_property(error, 'message', {
		value: error.message + `\n${component_stack}\n`
	});

	if (error.stack) {
		/*                          */
		define_property(error, 'stack', {
			value: error.stack
				.split('\n')
				.filter((line) => !line.includes('svelte/src/internal'))
				.join('\n')
		});
	}
}
